<script setup lang="ts">
import { INSTANT_EXPEDITIONS } from '~/shared/expedition'

const solutions = [
  'Melayani pengiriman paket hingga jarak 40 km dari lokasimu.',
  'Kirim paket besar atau kecil, tinggal pilih kendaraan yang sesuai.',
  'Kirim dokumen hingga makanan, semua tiba dalam hitungan jam.'
]
</script>

<template>
  <div class="flex flex-col gap-11 py-4 lg:py-16">
    <UiSectionWrapper
      image-class="lg:order-first"
      title="Kirim Paket Cepat Setiap Saat"
      description="Pengiriman instant selalu siap dipesan kapan saja dalam 24 jam, untuk lebih cepat penuhi permintaan pelangganmu."
      hero-image="/images/batch-2/instant-add-1.webp"
    >
      <template #action>
        <div class="mt-6 lg:mt-12 flex flex-col gap-6 text-lg leading-7">
          <div
            v-for="(solution, index) in solutions"
            :key="index"
            class="flex gap-2"
          >
            <Icon
              class="text-primary flex-none"
              name="material-symbols:verified"
              size="24px"
            />
            <p class="text-sm lg:text-lg flex-1">
              {{ solution }}
            </p>
          </div>
        </div>
      </template>
    </UiSectionWrapper>
    <UiContainer class="flex sm:justify-center">
      <div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 pb-8">
        <UiCourierService
          v-for="(expedition, index) in INSTANT_EXPEDITIONS"
          :key="index"
          :service-name="expedition.courier"
          :company="expedition.company_name"
          :icon="expedition.icon"
          :icon-class="expedition.class"
          class="flex-1 min-w-3xs max-w-xs"
        />
      </div>
    </UiContainer>
  </div>
</template>
